import { Button, Group } from '@mantine/core';
import React from 'react';

interface Props {
  isBusy: boolean;
  handleClick: () => void;
}
function RefundButton(props: Props) {
  const { handleClick, isBusy } = props;
  return (
    <Button 
      disabled={isBusy}
      variant="filled" 
      color="red"
      px='xs'
      data-cy='refundButton'
      onClick={() => {
        handleClick();
      }}
      style={{
        marginLeft: "5px",
        marginRight: "5px",
        marginTop: "10px"
      }}
    >
      <Group spacing='xs'>{ isBusy ? "Refunding..." : "Refund" }</Group>
    </Button>
  );
}

export default RefundButton;
